import styled from 'styled-components';
import colors from '../../config/colors';

const PaginateWrapper = styled.div`

  .pagination {
    list-style: none;
    padding: 0;
    margin: 20px 0 0;
    text-align: center;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
    z-index: 1;

    @media (max-width: 767px) {
      min-height: 24px;
      padding: 0 32px;
      justify-content: center;
    }

    li {
      display: inline-block;

      a {
        display: block;
        width: 24px;
        height: 24px;
        font-size: 14px;
        color: ${colors.TEXT_BLACK};
        border-radius: 50%;
        cursor: pointer;
        padding: 5px 2px;
        transition: all 100ms ease-in-out;
      }

      &.active,
      &:hover {

        a {
          background: ${colors.PRIMARY_PURPLE_LIGHT};
          color: ${colors.WHITE_COLOR};
        }
      }

      &.active {

        a {
          cursor: default;
        }
      }

      &.previous {
        margin-right: auto;

        @media (max-width: 767px) {
          left: 0;
        }

        img, .isvg {
          margin-right: 15px;
        }

        .arrow-link {
          img, .isvg {
            transform: rotate(180deg);
          }
        }
      }

      &.next {
        margin-left: auto;

        @media (max-width: 767px) {
          right: 0;
        }

        img, .isvg {
          margin-left: 15px;
        }
      }

      &.previous,
      &.next {
        text-transform: uppercase;

        @media (max-width: 767px) {
          position: absolute;
          top: 0;
        }

        a {
          width: auto;
          height: auto;
          background: none;
          padding: 0;
          border-radius: 0;
          transition: all 100ms ease-in-out;

          &:hover {
            opacity: 0.7;
            color: ${colors.PURPLE_COLOR};
          }
        }

        .arrow-link {
          display: flex;
          margin-left: 12px;

          img, .isvg {
            margin: 0;
          }
        }

        img, .isvg {
          display: inline-block;
          vertical-align: middle;
          width: 30px;
          height: 30px;

          @media (max-width: 767px) {
            width: 24px;
            height: 24px;
          }
        }
      }
    }

    &.arrows {
      position: absolute;
      top: 30px;
      right: 14px;
      margin: 0;

      @media (max-width: 767px) {
        min-height: 0;
        padding: 0;
        justify-content: normal;
      }

      .previous,
      .next {

        @media (max-width: 767px) {
          position: static;
          top: auto;
          left: auto;
        }

        img, svg {
          width: 20px;
          height: 20px;
        }
      }

      .next {
        transform: rotate(180deg);
        margin-left: 10px;
      }

      .break, .active {
        display: none !important;
      }

      span {
        display: inline-flex;
        cursor: pointer;
        margin-left: 12px;
        transition: opacity 100ms ease-in-out;

        i {
          display: inherit;
          transform: rotate(180deg);
        }

        &:hover {
          opacity: 0.5;
        }
      }

      img, svg {
        width: 20px;
        height: 20px;
      }
    }
  }

  .pagination-white {
    list-style: none;
    padding: 0;
    margin: 20px 0;
    text-align: center;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
    z-index: 1;
    justify-content: flex-end;

    @media (max-width: 576px) {
      margin: 14px 0;
    }

    li {
      display: inline-block;

      a {
        font-family: 'Gilroy-Medium';
        width: 38px;
        height: 38px;
        color: ${colors.BLACK};
        background: ${colors.WHITE};
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin: 3px;
        transition: all 100ms ease-in-out;

        @media (max-width: 576px) {
          width: 24px;
          height: 24px;
          font-size: 12px;
          margin: 2px;
        }
      }

      svg {
        width: 7px;
        height: 12px;
        color: ${colors.BLACK_COLOR};
        stroke: ${colors.BLACK_COLOR};
        transition: all 100ms ease-in-out;

        @media (max-width: 576px) {
          width: 6px;
          height: 10px;
        }
      }

      &.active,
      &:hover {

        a {
          background: ${colors.PRIMARY_PURPLE_LIGHT};
          color: ${colors.WHITE};
        }
        svg {
          fill: ${colors.WHITE};
          color: ${colors.WHITE};
          stroke: ${colors.WHITE};
        }
      }
    }
  }

  .pagination-gray {
    list-style: none;
    padding: 0;
    margin: 20px 0;
    text-align: center;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
    z-index: 1;
    justify-content: flex-end;

    @media (max-width: 576px) {
      margin: 14px 0;
    }

    li {
      display: inline-block;

      a {
        font-family: 'Gilroy-Medium';
        width: 38px;
        height: 38px;
        color: ${colors.BLACK};
        background: ${colors.GRAY_EXTRA_LIGHT};
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin: 3px;
        transition: all 100ms ease-in-out;

        @media (max-width: 576px) {
          width: 24px;
          height: 24px;
          font-size: 12px;
          margin: 2px;
        }
      }

      svg {
        width: 7px;
        height: 12px;
        color: ${colors.BLACK_COLOR};
        stroke: ${colors.BLACK_COLOR};
        transition: all 100ms ease-in-out;

        @media (max-width: 576px) {
          width: 6px;
          height: 10px;
        }
      }

      &.active,
      &:hover {

        a {
          background: ${colors.PRIMARY_PURPLE_LIGHT};
          color: ${colors.WHITE};
        }
        svg {
          color: ${colors.WHITE};
          fill: ${colors.WHITE};
          stroke: ${colors.WHITE};
        }
      }
    }
  }

  .pagination-arrows {
    list-style: none;
    padding: 0;
    margin: 20px 0 0;
    li {
      display: inline-block;
      a {
        width: 38px;
        height: 38px;
        color: ${colors.BLACK};
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 100ms ease-in-out;

        @media (max-width: 992px) {
          width: 18px;
        }
      }
      svg {
        width: 12px;
        height: 17px;
        stroke: ${colors.BLACK};
        transition: all 100ms ease-in-out;
      }
    }
    .previous {
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -19px;
    }
    .next {
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -19px;
    }
    .previous,
    .next {

      &.disabled {
        pointer-events: none;

        svg {
          stroke: ${colors.GRAY_LIGHT} !important;
        }
      }
    }

    .active, .break {
      display: none;
    }
  }
`;

export default PaginateWrapper;
